import React from 'react';

import { flagStyles } from '../settings';

const SvgSX = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5016px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSX;
